import {
    currentCulture
} from '../culture';


export default {
    methods: {
        culture(){
            return currentCulture();
        }
    }
};